export default __webpack_public_path__ + "assets/1fe8e2c8b487bf0ccd377df85fef8355.woff";